export default __webpack_public_path__ + "static/media/136.23fea153.jpg";